const hideFocusRingsDataAttribute = "data-braid-hidefocusrings";
export {
  hideFocusRingsDataAttribute
};
